import React from 'react';
import { connect } from 'react-redux';
import ContactForm from '../../components/ContactForm/ContactForm';
import { __ } from '../../helpers/TranslationService';
import { IState } from '../../reducers';
import { AdvisorImage, AdvisorPhone } from './components/Advisor';

interface IProps {
    image: string;
    name: string;
    companies: string;
    languages: string;
    phone: string;
    formSent: boolean; // From redux state
}

const AdvisorModalComponent = (props: IProps) => {
    const advisor = {
        name: props.name,
        phone: props.phone,
        companies: props.companies,
        languages: props.languages,
    };

    return (
        <div className="advisorModal">
            {!props.formSent && (
                <>
                    <h3>{__('Get in Contact with us!', 'dreamlines')}</h3>
                    <p>
                        {__(
                            'Fill in this enquiry and your expert replys as soon as possible',
                            'dreamlines',
                        )}
                    </p>
                    <div className="AdvisorModalInfo">
                        <AdvisorImage image={props.image} />
                        <div className="advisorDetails">
                            <h4>{props.name}</h4>
                            <p>{props.companies}</p>
                        </div>
                    </div>
                </>
            )}

            <ContactForm channel="advisorModal" advisor={advisor} />
        </div>
    );
};

const mapStateToProps = (state: IState) => ({
    formSent: state.contactForm.advisorModal.isSent,
});

export const AdvisorModal = connect(mapStateToProps, {})(AdvisorModalComponent);
export default AdvisorModal;
